import React, { useState } from 'react'
import styles from '../../../pages/Home.module.css'
import { RequestPandingIcon } from '../../icons/Icon2';
import { useAuth } from '../../context/Auth';
import { LogInBtnIcon } from '../../icons/Icon';
import ModalWrapper from '../layoutWrapper/ModalWrapper';
import Button from '../Dealers/Button';
const RequestPending = ({ loading, handleClick }) => {

    const { mode } = useAuth();
    const [modelOpen, setModelOpen] = useState(false)
    return (
        <div
            className={styles.login_container}
            style={mode ? { backgroundColor: "#2C2E33" } : {}}
        >

            <ModalWrapper isOpen={modelOpen} onClose={() => setModelOpen(!modelOpen)}>
                <div>
                    <div
                        className={styles.Device_Continer}
                        style={
                            mode
                                ? { backgroundColor: "#2C2E33", color: "#fff" }
                                : { backgroundColor: "#fff", color: "#000" }
                        }
                    >
                        <p className={styles.Device_Continer_fristp} style={{ lineHeight: 0 }} >
                            Logout device
                        </p>
                        <p className={styles.Device_Continer_SandP}
                            style={{}} >
                            Do you want Shue to log out of this device?
                            {/* This device request is still pending admin verification.
                            Do you want to log out from this device? */}
                        </p>
                        <div className={styles.Device_img_Continer}>
                            <img
                                className={styles.image_continer}
                                src='assets\updatedAssets/logout_img.png'
                                alt='logout_img.png' />
                        </div>

                        <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                            <Button
                                buttonText={"No"}
                                buttonBgColor={"#4164E3"}
                                buttonTextColor={"#ffffff"}
                                buttonBorder={"none"}
                                buttonClick={() => setModelOpen(false)}
                            // loading={loading}
                            />
                            <Button
                                buttonText={"Yes"}
                                buttonBgColor={"#000000ff"}
                                buttonTextColor={"#ffffff"}
                                buttonBorder={"none"}
                                loading={loading}
                                buttonClick={handleClick}
                            />
                        </div>
                    </div>
                </div>
            </ModalWrapper>

            <div
                className={styles.login1}
                style={mode ? { backgroundColor: "#232529" } : {}}
            >
                <div className={styles.sub_Login}>
                    <div className={styles.login_Header}>
                        <div className={styles.login_Header_Text}>
                            <h2 style={mode ? { color: "#ffffff" } : {}}> Device Registration
                                Request Pending
                            </h2>
                            <p style={mode ? { color: "#9C9797" } : {}}>
                                Your device registration is still pending. you have to wait for the approval.
                            </p>
                        </div>
                        <div>
                            <RequestPandingIcon />
                        </div>
                    </div>
                    <form
                        className={styles.login_Form}
                        onSubmit={(e) => {
                            e.preventDefault();
                            setModelOpen(true);
                        }}
                    >
                        <button
                            type="submit"
                            disabled={loading}
                            className={styles.login_button}
                        >
                            <>
                                <LogInBtnIcon />
                                <p>Log Out</p>
                            </>
                        </button>
                    </form>
                    <div style={{ marginTop: "40px" }}></div>
                </div>
            </div>
        </div>
    )
}

export default RequestPending


